import _callSuper from "/Users/dayanamartinez/Developer/laas_simulator/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/Users/dayanamartinez/Developer/laas_simulator/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/Users/dayanamartinez/Developer/laas_simulator/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _toConsumableArray from "/Users/dayanamartinez/Developer/laas_simulator/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/Users/dayanamartinez/Developer/laas_simulator/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _createClass from "/Users/dayanamartinez/Developer/laas_simulator/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/Users/dayanamartinez/Developer/laas_simulator/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
var _0x7f9bb9 = _0x53be;
(function (_0x5ba147, _0x3dca0c) {
  var _0x496846 = _0x53be,
    _0x4bafe2 = _0x5ba147();
  while (!![]) {
    try {
      var _0x371a18 = -parseInt(_0x496846(0x1cf)) / 0x1 * (parseInt(_0x496846(0x1b5)) / 0x2) + parseInt(_0x496846(0x144)) / 0x3 * (-parseInt(_0x496846(0x187)) / 0x4) + parseInt(_0x496846(0x1f6)) / 0x5 + parseInt(_0x496846(0x18d)) / 0x6 * (-parseInt(_0x496846(0x116)) / 0x7) + -parseInt(_0x496846(0x165)) / 0x8 * (-parseInt(_0x496846(0x141)) / 0x9) + parseInt(_0x496846(0x197)) / 0xa + parseInt(_0x496846(0x10a)) / 0xb;
      if (_0x371a18 === _0x3dca0c) break;else _0x4bafe2['push'](_0x4bafe2['shift']());
    } catch (_0x272a74) {
      _0x4bafe2['push'](_0x4bafe2['shift']());
    }
  }
})(_0x3abf, 0xaf06e);
function __awaiter(_0x4f7541, _0x5f2bdd, _0x4432f0, _0x196bf7) {
  function _0x449d02(_0x4bd572) {
    return _0x4bd572 instanceof _0x4432f0 ? _0x4bd572 : new _0x4432f0(function (_0x426a32) {
      _0x426a32(_0x4bd572);
    });
  }
  return new (_0x4432f0 || (_0x4432f0 = Promise))(function (_0x535743, _0x4c46b1) {
    var _0x10ab60 = _0x53be;
    function _0x2a2b6(_0x379ef4) {
      var _0x448ad3 = _0x53be;
      try {
        _0x3cb7b5(_0x196bf7[_0x448ad3(0x1c2)](_0x379ef4));
      } catch (_0xc3940a) {
        _0x4c46b1(_0xc3940a);
      }
    }
    function _0x5f12e0(_0x4eb124) {
      var _0x1620f4 = _0x53be;
      try {
        _0x3cb7b5(_0x196bf7[_0x1620f4(0x1b1)](_0x4eb124));
      } catch (_0x5e1651) {
        _0x4c46b1(_0x5e1651);
      }
    }
    function _0x3cb7b5(_0x3e5865) {
      var _0x1d74d5 = _0x53be;
      _0x3e5865[_0x1d74d5(0x12f)] ? _0x535743(_0x3e5865[_0x1d74d5(0x12d)]) : _0x449d02(_0x3e5865['value'])[_0x1d74d5(0x1e3)](_0x2a2b6, _0x5f12e0);
    }
    _0x3cb7b5((_0x196bf7 = _0x196bf7[_0x10ab60(0x14f)](_0x4f7541, _0x5f2bdd || []))[_0x10ab60(0x1c2)]());
  });
}
var EventModule;
(function (_0x25ebc6) {
  var _0x474712 = _0x53be;
  _0x25ebc6[_0x474712(0x211)] = _0x474712(0x211), _0x25ebc6[_0x474712(0x195)] = _0x474712(0x195), _0x25ebc6[_0x474712(0x180)] = 'PROCESS_ERROR', _0x25ebc6[_0x474712(0x1a2)] = _0x474712(0x1a2), _0x25ebc6['MODULE_READY'] = 'MODULE_READY', _0x25ebc6['CAMERA_ACCEPTED'] = _0x474712(0x106), _0x25ebc6[_0x474712(0x153)] = _0x474712(0x153), _0x25ebc6[_0x474712(0x132)] = _0x474712(0x132), _0x25ebc6[_0x474712(0xfd)] = _0x474712(0xfd);
})(EventModule || (EventModule = {}));
var FadEnvironment;
(function (_0x139ed7) {
  var _0x30baf5 = _0x53be;
  _0x139ed7[_0x139ed7['UAT'] = 0x1] = _0x30baf5(0x208), _0x139ed7[_0x139ed7[_0x30baf5(0x20a)] = 0x3] = 'PROD';
})(FadEnvironment || (FadEnvironment = {}));
var AdditionaInfoProcessType;
(function (_0x1baab0) {
  var _0x5b7656 = _0x53be;
  _0x1baab0[_0x1baab0['VALIDATION'] = 0x1] = _0x5b7656(0x182), _0x1baab0[_0x1baab0[_0x5b7656(0x1d0)] = 0x2] = 'ENROLLMENT', _0x1baab0[_0x1baab0[_0x5b7656(0x209)] = 0x3] = _0x5b7656(0x209), _0x1baab0[_0x1baab0['VIDEOCONFERENCE'] = 0x4] = 'VIDEOCONFERENCE', _0x1baab0[_0x1baab0[_0x5b7656(0x207)] = 0x5] = _0x5b7656(0x207);
})(AdditionaInfoProcessType || (AdditionaInfoProcessType = {}));
var IframePermissions;
(function (_0x49ab88) {
  var _0x18006b = _0x53be;
  _0x49ab88[_0x18006b(0x1f8)] = _0x18006b(0x20b), _0x49ab88[_0x18006b(0x181)] = 'camera;microphone', _0x49ab88['GEOLOCATION_CAMERA_MICROPHONE'] = _0x18006b(0x1fd);
})(IframePermissions || (IframePermissions = {}));
var RegulaCaptureType;
(function (_0x15fdef) {
  var _0x5064a0 = _0x53be;
  _0x15fdef[_0x5064a0(0xff)] = _0x5064a0(0xff), _0x15fdef[_0x5064a0(0x15e)] = _0x5064a0(0x15e);
})(RegulaCaptureType || (RegulaCaptureType = {}));
var FAD_IFRAME_UAT = _0x7f9bb9(0x108),
  FAD_IFRAME_PROD = 'uONj0U8CQuv6YdsxB6i6UV0tE7wyMTu2i1lcmd1FWz4tX+fwPVYP6TF2MAZND/ZPt6NHLA==',
  MODULES_URL = {
    'FACETEC': _0x7f9bb9(0x19f),
    'IDENTY': _0x7f9bb9(0x171),
    'VIDEOAGREEMENT': _0x7f9bb9(0x162),
    'VIDEOTAPING': 'fad-iframe-videotaping',
    'SIGNATURE': _0x7f9bb9(0x1ca),
    'VALIDATION_ID': _0x7f9bb9(0x152),
    'ACUANT': 'fad-iframe-acuant',
    'ACUANT_10': _0x7f9bb9(0x145),
    'REGULA': _0x7f9bb9(0x1d4)
  },
  FAD_WEB_UAT = _0x7f9bb9(0x15f),
  FAD_WEB_PROD = 'uONj0U8CQuv2ftA+Gaz5Uho5F68+JS6smERajd0NWX8jH+e+S+dZJ7rsETQjqLfkSFkkVuSR0hkmjkMy2jw=',
  FAD_DOMAIN = _0x7f9bb9(0x1f5),
  YEK = _0x7f9bb9(0x20f),
  VI = _0x7f9bb9(0x1c9),
  SDK_OPTIONS = {
    'environment': FadEnvironment[_0x7f9bb9(0x208)],
    'security': {
      'domain': FAD_DOMAIN,
      'enable': !![]
    }
  };
var LegendSpeedMode;
(function (_0x2c4040) {
  var _0x4141c0 = _0x7f9bb9;
  _0x2c4040[_0x2c4040[_0x4141c0(0x127)] = 0x1] = _0x4141c0(0x127), _0x2c4040[_0x2c4040[_0x4141c0(0x139)] = 0x2] = _0x4141c0(0x139), _0x2c4040[_0x2c4040[_0x4141c0(0x1d6)] = 0x3] = _0x4141c0(0x1d6);
})(LegendSpeedMode || (LegendSpeedMode = {}));
var IDS_ALLOWED;
(function (_0x35921d) {
  var _0xbf129 = _0x7f9bb9;
  _0x35921d[_0xbf129(0x1a3)] = _0xbf129(0x1a3), _0x35921d[_0xbf129(0x16c)] = _0xbf129(0x16c), _0x35921d[_0xbf129(0x1e1)] = _0xbf129(0x1e1);
})(IDS_ALLOWED || (IDS_ALLOWED = {}));
var SandBoxPermissions;
(function (_0x14ba1f) {
  var _0x33151f = _0x7f9bb9;
  _0x14ba1f[_0x33151f(0x14d)] = _0x33151f(0x1d5), _0x14ba1f[_0x33151f(0x1e9)] = 'allow-same-origin', _0x14ba1f[_0x33151f(0x155)] = _0x33151f(0x164), _0x14ba1f['ALLOW_FORMS'] = 'allow-forms', _0x14ba1f[_0x33151f(0x19e)] = '';
})(SandBoxPermissions || (SandBoxPermissions = {}));
var AcuantErrorCode;
(function (_0x1c963e) {
  var _0xab1652 = _0x7f9bb9;
  _0x1c963e[_0x1c963e[_0xab1652(0x1ea)] = -0x1] = 'REQUIRED_CREDENTIALS', _0x1c963e[_0x1c963e[_0xab1652(0x134)] = -0x2] = _0xab1652(0x134), _0x1c963e[_0x1c963e['UNSUPPORTED_CAMERA'] = -0x3] = _0xab1652(0x1ee), _0x1c963e[_0x1c963e[_0xab1652(0x16f)] = -0x4] = _0xab1652(0x16f), _0x1c963e[_0x1c963e['FAIL_CREATION_INSTANCE_DOCUMENT'] = -0x5] = _0xab1652(0x20e), _0x1c963e[_0x1c963e['FAIL_UPLOAD_IMAGE'] = -0x6] = _0xab1652(0x1ed), _0x1c963e[_0x1c963e[_0xab1652(0x11b)] = -0x7] = _0xab1652(0x11b), _0x1c963e[_0x1c963e['FAIL_GET_FACE_IMAGE'] = -0x8] = _0xab1652(0x12a), _0x1c963e[_0x1c963e[_0xab1652(0x212)] = -0x9] = 'FACE_IMAGE_URL_NOT_FOUND', _0x1c963e[_0x1c963e[_0xab1652(0x102)] = -0xa] = 'FACE_IMAGE_NOT_FOUND', _0x1c963e[_0x1c963e[_0xab1652(0x156)] = -0xb] = _0xab1652(0x156), _0x1c963e[_0x1c963e[_0xab1652(0x1a6)] = -0xc] = _0xab1652(0x1a6), _0x1c963e[_0x1c963e[_0xab1652(0x18f)] = -0xd] = _0xab1652(0x18f), _0x1c963e[_0x1c963e[_0xab1652(0x1f1)] = -0xe] = _0xab1652(0x1f1), _0x1c963e[_0x1c963e['DIFFERENT_ZONE'] = -0xf] = _0xab1652(0x1c1), _0x1c963e[_0x1c963e['EQUAL_SIDE'] = -0x10] = _0xab1652(0x1fb), _0x1c963e[_0x1c963e[_0xab1652(0x15b)] = -0x11] = _0xab1652(0x15b), _0x1c963e[_0x1c963e[_0xab1652(0x117)] = -0x12] = _0xab1652(0x117), _0x1c963e[_0x1c963e[_0xab1652(0x136)] = -0x13] = _0xab1652(0x136);
})(AcuantErrorCode || (AcuantErrorCode = {}));
var AcuantLegacyErrorCode;
(function (_0x29409f) {
  var _0x422bba = _0x7f9bb9;
  _0x29409f[_0x29409f[_0x422bba(0x1ea)] = -0x1] = 'REQUIRED_CREDENTIALS', _0x29409f[_0x29409f['FAIL_INITIALIZATION'] = -0x2] = 'FAIL_INITIALIZATION', _0x29409f[_0x29409f[_0x422bba(0x1ee)] = -0x3] = _0x422bba(0x1ee), _0x29409f[_0x29409f[_0x422bba(0x16f)] = -0x4] = 'FAIL_INITIALIZATION_CAMERA_UI', _0x29409f[_0x29409f[_0x422bba(0x20e)] = -0x5] = _0x422bba(0x20e), _0x29409f[_0x29409f['FAIL_UPLOAD_IMAGE'] = -0x6] = _0x422bba(0x1ed), _0x29409f[_0x29409f['FAIL_GET_OCR'] = -0x7] = _0x422bba(0x11b), _0x29409f[_0x29409f[_0x422bba(0x12a)] = -0x8] = 'FAIL_GET_FACE_IMAGE', _0x29409f[_0x29409f['FACE_IMAGE_URL_NOT_FOUND'] = -0x9] = _0x422bba(0x212), _0x29409f[_0x29409f['FACE_IMAGE_NOT_FOUND'] = -0xa] = _0x422bba(0x102), _0x29409f[_0x29409f[_0x422bba(0x156)] = -0xb] = 'RESOURCES_COULD_NOT_BE_LOADED', _0x29409f[_0x29409f['UNEXPECTED_ACUANT_ERROR'] = -0xc] = _0x422bba(0x1a6), _0x29409f[_0x29409f[_0x422bba(0x18f)] = -0xd] = 'UNSUPPORTED_IMAGE', _0x29409f[_0x29409f[_0x422bba(0x1f1)] = -0xe] = _0x422bba(0x1f1);
})(AcuantLegacyErrorCode || (AcuantLegacyErrorCode = {}));
var FacetecErrorCodeSession;
function _0x53be(_0x32396c, _0x426e53) {
  var _0x3abf65 = _0x3abf();
  return _0x53be = function _0x53be(_0x53be6f, _0x511432) {
    _0x53be6f = _0x53be6f - 0xfd;
    var _0x42f066 = _0x3abf65[_0x53be6f];
    return _0x42f066;
  }, _0x53be(_0x32396c, _0x426e53);
}
(function (_0x58118f) {
  var _0x48bb23 = _0x7f9bb9;
  _0x58118f[_0x58118f['NEVER_INITIALIZED'] = 0x0] = _0x48bb23(0x201), _0x58118f[_0x58118f[_0x48bb23(0x178)] = 0x1] = 'MISSING_GUIDANCE_IMAGES', _0x58118f[_0x58118f[_0x48bb23(0x1fe)] = 0x2] = _0x48bb23(0x1fe), _0x58118f[_0x58118f[_0x48bb23(0x1f3)] = 0x3] = _0x48bb23(0x1f3), _0x58118f[_0x58118f[_0x48bb23(0x214)] = 0x4] = _0x48bb23(0x214), _0x58118f[_0x58118f[_0x48bb23(0x17f)] = 0x5] = _0x48bb23(0x17f), _0x58118f[_0x58118f['LANDSCAPE_MODE_NOT_ALLOWED'] = 0x6] = 'LANDSCAPE_MODE_NOT_ALLOWED', _0x58118f[_0x58118f[_0x48bb23(0x12e)] = 0x7] = _0x48bb23(0x12e), _0x58118f[_0x58118f[_0x48bb23(0x186)] = 0x8] = _0x48bb23(0x186), _0x58118f[_0x58118f[_0x48bb23(0x14c)] = 0x9] = 'USER_CANCELLED_FROM_RETRY_GUIDANCE', _0x58118f[_0x58118f[_0x48bb23(0x1fc)] = 0xa] = _0x48bb23(0x1fc), _0x58118f[_0x58118f[_0x48bb23(0x18b)] = 0xb] = _0x48bb23(0x18b), _0x58118f[_0x58118f[_0x48bb23(0x1e6)] = 0xc] = _0x48bb23(0x1e6), _0x58118f[_0x58118f[_0x48bb23(0x119)] = 0xd] = _0x48bb23(0x119), _0x58118f[_0x58118f[_0x48bb23(0x128)] = 0xe] = _0x48bb23(0x128), _0x58118f[_0x58118f['SESSION_IN_PROGRESS'] = 0xf] = _0x48bb23(0x1dd), _0x58118f[_0x58118f[_0x48bb23(0x198)] = 0x10] = 'CAMERA_NOT_RUNNING', _0x58118f[_0x58118f[_0x48bb23(0x1c6)] = 0x11] = _0x48bb23(0x1c6), _0x58118f[_0x58118f['UNKNOWN_INTERNAL_ERROR'] = 0x12] = _0x48bb23(0x188), _0x58118f[_0x58118f[_0x48bb23(0x17b)] = 0x13] = _0x48bb23(0x17b), _0x58118f[_0x58118f[_0x48bb23(0x176)] = 0x14] = 'NOT_ALLOWED_USE_IFRAME_CONSTRUCTOR', _0x58118f[_0x58118f[_0x48bb23(0x125)] = 0x15] = 'NOT_ALLOWED_USE_NON_IFRAME_CONSTRUCTOR', _0x58118f[_0x58118f['I_FRAME_NOT_ALLOWED_WITHOUT_PERMISSION'] = 0x16] = _0x48bb23(0x1a5), _0x58118f[_0x58118f['STILL_LOADING_RESOURCES'] = 0x17] = 'STILL_LOADING_RESOURCES', _0x58118f[_0x58118f[_0x48bb23(0x1e7)] = 0x18] = _0x48bb23(0x1e7), _0x58118f[_0x58118f['RESOURCES_COULD_NOT_BE_LOADED'] = 0x19] = _0x48bb23(0x156), _0x58118f[_0x58118f[_0x48bb23(0x1ea)] = 0x1a] = _0x48bb23(0x1ea), _0x58118f[_0x58118f[_0x48bb23(0x1b4)] = 0x1b] = _0x48bb23(0x1b4), _0x58118f[_0x58118f[_0x48bb23(0x1ae)] = -0x1] = _0x48bb23(0x1ae);
})(FacetecErrorCodeSession || (FacetecErrorCodeSession = {}));
var FacetecErrorCodeStatus;
(function (_0x4a4320) {
  var _0x6989fa = _0x7f9bb9;
  _0x4a4320[_0x4a4320['NEVERIN_ITIALIZED'] = 0x0] = _0x6989fa(0x143), _0x4a4320[_0x4a4320[_0x6989fa(0x206)] = 0x1] = _0x6989fa(0x206), _0x4a4320[_0x4a4320['NETWORK_ISSUES'] = 0x2] = _0x6989fa(0x11f), _0x4a4320[_0x4a4320[_0x6989fa(0x1bb)] = 0x3] = 'INVALID_DEVICE_KEY_IDENTIFIER', _0x4a4320[_0x4a4320[_0x6989fa(0x1d3)] = 0x4] = _0x6989fa(0x1d3), _0x4a4320[_0x4a4320[_0x6989fa(0x168)] = 0x5] = _0x6989fa(0x168), _0x4a4320[_0x4a4320[_0x6989fa(0x1bf)] = 0x6] = 'DEVICE_IN_LANDSCAPE_MODE', _0x4a4320[_0x4a4320[_0x6989fa(0x16d)] = 0x7] = _0x6989fa(0x16d), _0x4a4320[_0x4a4320[_0x6989fa(0x179)] = 0x8] = _0x6989fa(0x179), _0x4a4320[_0x4a4320[_0x6989fa(0x1ad)] = 0x9] = _0x6989fa(0x1ad), _0x4a4320[_0x4a4320['STILL_LOADING_RESOURCES'] = 0xa] = _0x6989fa(0x1d9), _0x4a4320[_0x4a4320[_0x6989fa(0x1e7)] = 0xb] = _0x6989fa(0x1e7);
})(FacetecErrorCodeStatus || (FacetecErrorCodeStatus = {}));
var FacetecErrorType;
(function (_0x1a5139) {
  var _0x57fd5c = _0x7f9bb9;
  _0x1a5139[_0x57fd5c(0x11d)] = 'FaceTecSDKStatus', _0x1a5139[_0x57fd5c(0xfe)] = _0x57fd5c(0x18a), _0x1a5139[_0x57fd5c(0x140)] = _0x57fd5c(0x120);
})(FacetecErrorType || (FacetecErrorType = {}));
var IframeFacetecErrorCode;
(function (_0x113b07) {
  var _0x43bdc0 = _0x7f9bb9;
  _0x113b07[_0x113b07['FACETEC_MIDDLEWARE_CREDENTIALS'] = -0x1] = _0x43bdc0(0x137), _0x113b07[_0x113b07[_0x43bdc0(0x1da)] = -0x2] = _0x43bdc0(0x1da);
})(IframeFacetecErrorCode || (IframeFacetecErrorCode = {}));
var IdentyErrorCode;
(function (_0x54259e) {
  var _0x1d31b1 = _0x7f9bb9;
  _0x54259e[_0x54259e[_0x1d31b1(0x1de)] = -0x1] = _0x1d31b1(0x1de), _0x54259e[_0x54259e[_0x1d31b1(0x124)] = -0x2] = 'NO_FINGERS', _0x54259e[_0x54259e[_0x1d31b1(0x14e)] = -0x3] = _0x1d31b1(0x14e), _0x54259e[_0x54259e[_0x1d31b1(0x11e)] = -0x4] = _0x1d31b1(0x11e), _0x54259e[_0x54259e[_0x1d31b1(0x13d)] = -0x5] = _0x1d31b1(0x13d), _0x54259e[_0x54259e[_0x1d31b1(0x1c3)] = 0x64] = _0x1d31b1(0x1c3), _0x54259e[_0x54259e[_0x1d31b1(0x149)] = 0x65] = _0x1d31b1(0x149), _0x54259e[_0x54259e[_0x1d31b1(0x19d)] = 0x67] = _0x1d31b1(0x19d), _0x54259e[_0x54259e[_0x1d31b1(0x15c)] = 0x68] = _0x1d31b1(0x15c), _0x54259e[_0x54259e[_0x1d31b1(0x1fe)] = 0xca] = _0x1d31b1(0x1fe), _0x54259e[_0x54259e[_0x1d31b1(0x1ff)] = 0x191] = _0x1d31b1(0x1ff), _0x54259e[_0x54259e['FEEDBACK_RETRY_INSECURE'] = 0x198] = 'FEEDBACK_RETRY_INSECURE', _0x54259e[_0x54259e[_0x1d31b1(0x1a8)] = 0x1f4] = _0x1d31b1(0x1a8), _0x54259e[_0x54259e[_0x1d31b1(0x122)] = 0x1f5] = _0x1d31b1(0x122), _0x54259e[_0x54259e[_0x1d31b1(0x1be)] = 0x258] = _0x1d31b1(0x1be), _0x54259e[_0x54259e[_0x1d31b1(0x130)] = 0x25c] = _0x1d31b1(0x130);
})(IdentyErrorCode || (IdentyErrorCode = {}));
var RegulaErrorCode;
(function (_0x6b278b) {
  var _0x201059 = _0x7f9bb9;
  _0x6b278b[_0x6b278b['NO_CREDENTIALS'] = -0x1] = _0x201059(0x163), _0x6b278b[_0x6b278b[_0x201059(0x199)] = -0x2] = _0x201059(0x199), _0x6b278b[_0x6b278b[_0x201059(0x1c8)] = -0x3] = 'NO_CAPTURE_TYPE', _0x6b278b[_0x6b278b[_0x201059(0x172)] = -0x4] = _0x201059(0x172), _0x6b278b[_0x6b278b[_0x201059(0x1ec)] = -0x5] = 'ID_PHOTO_NOT_FOUND', _0x6b278b[_0x6b278b['OCR_NOT_FOUND'] = -0x6] = 'OCR_NOT_FOUND', _0x6b278b[_0x6b278b[_0x201059(0x15d)] = -0x7] = 'ID_NOT_FOUND', _0x6b278b[_0x6b278b[_0x201059(0x1ef)] = -0x8] = _0x201059(0x1ef), _0x6b278b[_0x6b278b['ERROR_PROCESSING'] = -0x9] = 'ERROR_PROCESSING', _0x6b278b[_0x6b278b['FILES_UPLOAD'] = -0xa] = 'FILES_UPLOAD', _0x6b278b[_0x6b278b[_0x201059(0x10b)] = -0xb] = 'FILE_FORMAT', _0x6b278b[_0x6b278b[_0x201059(0x1ab)] = -0xc] = _0x201059(0x1ab), _0x6b278b[_0x6b278b['CARD_MATCH'] = -0xd] = 'CARD_MATCH', _0x6b278b[_0x6b278b['WASM_ERROR'] = 0x1] = _0x201059(0x148), _0x6b278b[_0x6b278b[_0x201059(0x1c7)] = 0x2] = _0x201059(0x1c7), _0x6b278b[_0x6b278b[_0x201059(0x1b6)] = 0x3] = _0x201059(0x1b6), _0x6b278b[_0x6b278b[_0x201059(0x1c5)] = 0x4] = _0x201059(0x1c5), _0x6b278b[_0x6b278b[_0x201059(0x1dc)] = 0x5] = _0x201059(0x1dc), _0x6b278b[_0x6b278b[_0x201059(0x177)] = 0x6] = 'NOT_SUPPORTED', _0x6b278b[_0x6b278b[_0x201059(0x1e2)] = 0x7] = _0x201059(0x1e2), _0x6b278b[_0x6b278b[_0x201059(0x1d1)] = 0x8] = _0x201059(0x1d1), _0x6b278b[_0x6b278b[_0x201059(0x147)] = 0x9] = _0x201059(0x147), _0x6b278b[_0x6b278b[_0x201059(0x1bd)] = 0xa] = _0x201059(0x1bd), _0x6b278b[_0x6b278b[_0x201059(0x19b)] = 0xb] = 'CONNECTION_ERROR', _0x6b278b[_0x6b278b[_0x201059(0x138)] = 0xc] = _0x201059(0x138), _0x6b278b[_0x6b278b[_0x201059(0x1e8)] = 0xd] = 'NOT_INITIALIZED', _0x6b278b[_0x6b278b[_0x201059(0x1e0)] = 0xe] = 'IN_PROCESS', _0x6b278b[_0x6b278b['ALREADY_PREPARED'] = 0xf] = 'ALREADY_PREPARED', _0x6b278b[_0x6b278b[_0x201059(0x1a9)] = 0x10] = _0x201059(0x1a9), _0x6b278b[_0x6b278b[_0x201059(0x1f2)] = 0x11] = _0x201059(0x1f2);
})(RegulaErrorCode || (RegulaErrorCode = {}));
var SignatureErrorCode;
(function (_0x552957) {
  var _0x3fd4a7 = _0x7f9bb9;
  _0x552957[_0x552957['BROWSER_NOT_SUPPORTED'] = -0x1] = _0x3fd4a7(0x192), _0x552957[_0x552957[_0x3fd4a7(0x1a0)] = -0x2] = _0x3fd4a7(0x1a0), _0x552957[_0x552957[_0x3fd4a7(0x1ce)] = -0x3] = 'VIDEO_CREATION_FAIL', _0x552957[_0x552957[_0x3fd4a7(0x10f)] = -0x4] = 'MEDIA_RECORDER_ERROR', _0x552957[_0x552957[_0x3fd4a7(0x159)] = -0x5] = _0x3fd4a7(0x159), _0x552957[_0x552957[_0x3fd4a7(0x13a)] = -0x6] = _0x3fd4a7(0x13a), _0x552957[_0x552957[_0x3fd4a7(0x194)] = -0x7] = 'VIDEO_EMPTY', _0x552957[_0x552957[_0x3fd4a7(0x1e5)] = -0x8] = _0x3fd4a7(0x1e5), _0x552957[_0x552957[_0x3fd4a7(0x1ba)] = -0x9] = 'FAIL_LOAD_WASM', _0x552957[_0x552957['NOT_READABLE_CAMERA'] = -0xa] = 'NOT_READABLE_CAMERA', _0x552957[_0x552957[_0x3fd4a7(0x1af)] = -0xb] = _0x3fd4a7(0x1af), _0x552957[_0x552957['NO_AUDIO'] = -0xc] = _0x3fd4a7(0x16e), _0x552957[_0x552957[_0x3fd4a7(0x1f3)] = -0xd] = _0x3fd4a7(0x1f3);
})(SignatureErrorCode || (SignatureErrorCode = {}));
var ValidationIdErrorCode;
(function (_0x4bd038) {
  var _0xaf8abd = _0x7f9bb9;
  _0x4bd038[_0x4bd038[_0xaf8abd(0x16a)] = -0x1] = 'NO_SERVICE', _0x4bd038[_0x4bd038[_0xaf8abd(0x135)] = -0x2] = 'NO_INTERNET', _0x4bd038[_0x4bd038[_0xaf8abd(0x1ea)] = -0x3] = _0xaf8abd(0x1ea), _0x4bd038[_0x4bd038[_0xaf8abd(0x205)] = -0x4] = 'BAD_CREDENTIALS', _0x4bd038[_0x4bd038[_0xaf8abd(0x114)] = -0x5] = 'USER_NOT_EXIST', _0x4bd038[_0x4bd038[_0xaf8abd(0x1d7)] = -0x6] = _0xaf8abd(0x1d7), _0x4bd038[_0x4bd038[_0xaf8abd(0x1cb)] = -0x7] = 'FAILED_SEND_VALIDATION', _0x4bd038[_0x4bd038['NO_CITIZEN_IDENTIFIER'] = -0x8] = _0xaf8abd(0x11a), _0x4bd038[_0x4bd038[_0xaf8abd(0x105)] = -0x9] = _0xaf8abd(0x105), _0x4bd038[_0x4bd038[_0xaf8abd(0x1f4)] = -0xa] = _0xaf8abd(0x1f4), _0x4bd038[_0x4bd038[_0xaf8abd(0x169)] = -0xb] = _0xaf8abd(0x169), _0x4bd038[_0x4bd038[_0xaf8abd(0x121)] = -0xc] = _0xaf8abd(0x121), _0x4bd038[_0x4bd038['INVALID_DATA'] = -0xd] = _0xaf8abd(0x1b8), _0x4bd038[_0x4bd038['UNKNOWN'] = -0x64] = _0xaf8abd(0x1a7);
})(ValidationIdErrorCode || (ValidationIdErrorCode = {}));
var VideoagreementErrorCode;
(function (_0x2d47a4) {
  var _0x58cb61 = _0x7f9bb9;
  _0x2d47a4[_0x2d47a4[_0x58cb61(0x192)] = -0x1] = _0x58cb61(0x192), _0x2d47a4[_0x2d47a4[_0x58cb61(0x1a0)] = -0x2] = _0x58cb61(0x1a0), _0x2d47a4[_0x2d47a4[_0x58cb61(0x1ce)] = -0x3] = _0x58cb61(0x1ce), _0x2d47a4[_0x2d47a4['MEDIA_RECORDER_ERROR'] = -0x4] = _0x58cb61(0x10f), _0x2d47a4[_0x2d47a4[_0x58cb61(0x159)] = -0x5] = _0x58cb61(0x159), _0x2d47a4[_0x2d47a4[_0x58cb61(0x184)] = -0x6] = _0x58cb61(0x184), _0x2d47a4[_0x2d47a4[_0x58cb61(0x194)] = -0x7] = _0x58cb61(0x194), _0x2d47a4[_0x2d47a4[_0x58cb61(0x1b2)] = -0x8] = _0x58cb61(0x1b2), _0x2d47a4[_0x2d47a4[_0x58cb61(0x1af)] = -0x9] = _0x58cb61(0x1af), _0x2d47a4[_0x2d47a4[_0x58cb61(0x16e)] = -0xa] = _0x58cb61(0x16e), _0x2d47a4[_0x2d47a4[_0x58cb61(0x1f3)] = -0xb] = _0x58cb61(0x1f3), _0x2d47a4[_0x2d47a4[_0x58cb61(0x1c4)] = -0xc] = _0x58cb61(0x1c4);
})(VideoagreementErrorCode || (VideoagreementErrorCode = {}));
var VideotapingErrorCode;
(function (_0x54ffe0) {
  var _0x157459 = _0x7f9bb9;
  _0x54ffe0[_0x54ffe0[_0x157459(0x192)] = -0x1] = _0x157459(0x192), _0x54ffe0[_0x54ffe0[_0x157459(0x1a0)] = -0x2] = _0x157459(0x1a0), _0x54ffe0[_0x54ffe0[_0x157459(0x1ce)] = -0x3] = _0x157459(0x1ce), _0x54ffe0[_0x54ffe0[_0x157459(0x10f)] = -0x4] = _0x157459(0x10f), _0x54ffe0[_0x54ffe0[_0x157459(0x159)] = -0x5] = _0x157459(0x159), _0x54ffe0[_0x54ffe0[_0x157459(0x184)] = -0x6] = _0x157459(0x184), _0x54ffe0[_0x54ffe0[_0x157459(0x194)] = -0x7] = _0x157459(0x194), _0x54ffe0[_0x54ffe0[_0x157459(0x1b2)] = -0x8] = 'NOT_READABLE_CAMERA', _0x54ffe0[_0x54ffe0[_0x157459(0x213)] = -0x9] = _0x157459(0x213), _0x54ffe0[_0x54ffe0[_0x157459(0x193)] = -0xa] = _0x157459(0x193), _0x54ffe0[_0x54ffe0[_0x157459(0x1af)] = -0xb] = _0x157459(0x1af), _0x54ffe0[_0x54ffe0[_0x157459(0x1c0)] = -0xc] = 'IDENTIFICATIONS_REQUIRED', _0x54ffe0[_0x54ffe0['NO_AUDIO'] = -0xd] = _0x157459(0x16e), _0x54ffe0[_0x54ffe0['CONTEXT_SWITCH'] = -0xe] = _0x157459(0x1f3);
})(VideotapingErrorCode || (VideotapingErrorCode = {}));
var INSECURE_ORIGIN = _0x7f9bb9(0x1b7);
var ResponseEvent = /*#__PURE__*/_createClass(function ResponseEvent(_0x7c6c2c, _0x4a5389) {
  _classCallCheck(this, ResponseEvent);
  var _0x15ef69 = _0x7f9bb9;
  this[_0x15ef69(0x154)] = _0x7c6c2c, this[_0x15ef69(0x200)] = _0x4a5389;
});
function startFadSDKProcess(_0x56024a, _0x272c7f, _0x4071e0) {
  return new Promise(function (_0x5c019a, _0x2699bb) {
    var _0x336c54 = _0x53be;
    console[_0x336c54(0x1eb)](_0x336c54(0x118));
    var _0x5400b = function _0x5400b7(_0x3361e7) {
      var _0x460b0b;
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _0x135acd;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _0x135acd = _0x53be;
              !isSecure(_0x3361e7[_0x135acd(0x20c)], _0x4071e0) && (window[_0x135acd(0x183)](_0x135acd(0x167), _0x5400b), removeFadTagElement(_0x56024a), _0x2699bb({
                'error': INSECURE_ORIGIN
              }));
              if (_0x3361e7[_0x135acd(0x200)][_0x135acd(0x154)] === EventModule['MODULE_READY']) console[_0x135acd(0x1eb)]('Module\x20ready'), (_0x460b0b = _0x56024a[_0x135acd(0x142)]) === null || _0x460b0b === void 0x0 ? void 0x0 : _0x460b0b[_0x135acd(0x1f0)](new ResponseEvent(EventModule[_0x135acd(0x211)], _0x272c7f), _0x56024a[_0x135acd(0x12b)]);else {
                if (_0x3361e7[_0x135acd(0x200)][_0x135acd(0x154)] === EventModule[_0x135acd(0x180)]) console[_0x135acd(0x1eb)]('Module\x20error'), window[_0x135acd(0x183)](_0x135acd(0x167), _0x5400b), removeFadTagElement(_0x56024a), _0x2699bb(_0x3361e7['data'][_0x135acd(0x200)]);else {
                  if (_0x3361e7[_0x135acd(0x200)][_0x135acd(0x154)] === EventModule[_0x135acd(0x1a2)]) console[_0x135acd(0x1eb)](_0x135acd(0x133)), window[_0x135acd(0x183)]('message', _0x5400b), removeFadTagElement(_0x56024a), _0x5c019a({
                    'event': _0x3361e7[_0x135acd(0x200)]['event'],
                    'data': _0x3361e7['data']['data']
                  });else _0x3361e7[_0x135acd(0x200)][_0x135acd(0x154)] === EventModule[_0x135acd(0x153)] && (console[_0x135acd(0x1eb)](_0x135acd(0x1aa)), window[_0x135acd(0x183)](_0x135acd(0x167), _0x5400b), removeFadTagElement(_0x56024a), _0x5c019a({
                    'event': _0x3361e7[_0x135acd(0x200)][_0x135acd(0x154)]
                  }));
                }
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    };
    window[_0x336c54(0x115)](_0x336c54(0x167), _0x5400b), addElementToFadTag(_0x56024a);
  });
}
function startFadWebProcess(_0x140a57, _0x1e1d52) {
  return new Promise(function (_0x1fc059, _0x185eb3) {
    var _0x2c1ace = _0x53be;
    console[_0x2c1ace(0x1eb)](_0x2c1ace(0x190));
    var _0x30b = function _0x30b72(_0x597d9a) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _0x45c50c;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _0x45c50c = _0x53be;
              !isSecure(_0x597d9a[_0x45c50c(0x20c)], _0x1e1d52) && (window[_0x45c50c(0x183)](_0x45c50c(0x167), _0x30b), removeFadTagElement(_0x140a57), _0x185eb3({
                'error': INSECURE_ORIGIN
              }));
              if (_0x597d9a[_0x45c50c(0x200)][_0x45c50c(0x154)] === EventModule[_0x45c50c(0x195)]) console[_0x45c50c(0x1eb)]('Process\x20init');else {
                if (_0x597d9a[_0x45c50c(0x200)][_0x45c50c(0x154)] === EventModule['PROCESS_ERROR']) console[_0x45c50c(0x1eb)](_0x45c50c(0x1fa)), window[_0x45c50c(0x183)](_0x45c50c(0x167), _0x30b), removeFadTagElement(_0x140a57), _0x185eb3(_0x597d9a[_0x45c50c(0x200)]['data']);else {
                  if (_0x597d9a['data']['event'] === EventModule['ENTRY_PATH']) console[_0x45c50c(0x1eb)]('Entry\x20path:\x20', _0x597d9a['data']['data']);else _0x597d9a[_0x45c50c(0x200)][_0x45c50c(0x154)] === EventModule[_0x45c50c(0x1a2)] && (console[_0x45c50c(0x1eb)](_0x45c50c(0x13f)), window['removeEventListener'](_0x45c50c(0x167), _0x30b), _0x1fc059(_0x597d9a[_0x45c50c(0x200)][_0x45c50c(0x200)]));
                }
              }
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
    };
    window[_0x2c1ace(0x115)](_0x2c1ace(0x167), _0x30b), addElementToFadTag(_0x140a57);
  });
}
function isSecure(_0x5114e8, _0xec8d2e) {
  var _0x552232, _0x472894;
  return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var _0x4f8796;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _0x4f8796 = _0x53be;
          if (!_0xec8d2e[_0x4f8796(0x1ac)]) {
            _context3.next = 8;
            break;
          }
          _context3.t0 = _0x5114e8;
          _context3.t1 = _0x4f8796(0x170);
          _context3.next = 6;
          return decipher(FAD_DOMAIN, YEK, VI);
        case 6:
          _context3.t2 = _context3.sent;
          return _context3.abrupt("return", _context3.t0[_context3.t1].call(_context3.t0, _context3.t2));
        case 8:
          if (!((_0x552232 = _0xec8d2e === null || _0xec8d2e === void 0x0 ? void 0x0 : _0xec8d2e[_0x4f8796(0x112)]) === null || _0x552232 === void 0x0 ? void 0x0 : _0x552232['enable'])) {
            _context3.next = 24;
            break;
          }
          _context3.t3 = _0x5114e8;
          _context3.t4 = _0x4f8796(0x170);
          _context3.t5 = (_0x472894 = _0xec8d2e === null || _0xec8d2e === void 0x0 ? void 0x0 : _0xec8d2e[_0x4f8796(0x112)]) === null || _0x472894 === void 0x0 ? void 0x0 : _0x472894[_0x4f8796(0x14b)];
          if (_context3.t5) {
            _context3.next = 16;
            break;
          }
          _context3.next = 15;
          return decipher(FAD_DOMAIN, YEK, VI);
        case 15:
          _context3.t5 = _context3.sent;
        case 16:
          _context3.t6 = _context3.t5;
          if (!_context3.t3[_context3.t4].call(_context3.t3, _context3.t6)) {
            _context3.next = 21;
            break;
          }
          return _context3.abrupt("return", !![]);
        case 21:
          return _context3.abrupt("return", ![]);
        case 22:
          _context3.next = 25;
          break;
        case 24:
          return _context3.abrupt("return", !![]);
        case 25:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
}
function removeFadTagElement(_0x5f2fd7) {
  var _0x2cff72 = _0x7f9bb9;
  var _0x5237c1, _0x2f61aa;
  var _0x4bcaf2 = getFadTag();
  ((_0x5237c1 = _0x4bcaf2 === null || _0x4bcaf2 === void 0x0 ? void 0x0 : _0x4bcaf2[_0x2cff72(0x1a1)]) === null || _0x5237c1 === void 0x0 ? void 0x0 : _0x5237c1['hasChildNodes']()) && ((_0x2f61aa = _0x4bcaf2 === null || _0x4bcaf2 === void 0x0 ? void 0x0 : _0x4bcaf2[_0x2cff72(0x1a1)]) === null || _0x2f61aa === void 0x0 ? void 0x0 : _0x2f61aa[_0x2cff72(0x17a)](_0x5f2fd7));
}
function getFadTag() {
  var _0x2f08e4 = _0x7f9bb9;
  return document[_0x2f08e4(0x13b)]['querySelector'](_0x2f08e4(0x191));
}
function _0x3abf() {
  var _0x3c6610 = ['attachShadow', '6uCLepx', 'getBaseUrl', 'UNSUPPORTED_IMAGE', 'Starts\x20FAD\x20Web\x204\x20Process', '#fad-sdk', 'BROWSER_NOT_SUPPORTED', 'TENSORFLOW_LOAD_FAIL', 'VIDEO_EMPTY', 'PROCESS_INIT', '100%', '4342660lrhdFM', 'CAMERA_NOT_RUNNING', 'NO_LICENSE', 'decode', 'CONNECTION_ERROR', 'forEach', 'ERROR_BROWSER_VERSION_NOT_SUPPORTED', 'ALLOW_FULLSCREEN', 'fad-iframe-facetec', 'NOT_ACCEPT_CAMERA_PERMISSION', 'shadowRoot', 'PROCESS_COMPLETED', 'ID_MEX_FRONT', 'allow', 'I_FRAME_NOT_ALLOWED_WITHOUT_PERMISSION', 'UNEXPECTED_ACUANT_ERROR', 'UNKNOWN', 'SERVER_ERROR', 'ALREADY_INITIALIZED', 'Module\x20closed', 'BASE64', 'environment', 'IFRAME_NOT_ALLOWED_WITHOUT_PERMISSION', 'MAX_ATTEMPTS', 'MEDIA_RECORDER_NOT_SUPPORTED', 'AES-GCM', 'throw', 'NOT_READABLE_CAMERA', 'startSignature', 'REQUIRED_MIDDLEWARE_INFO', '22mhVqbt', 'FILE_SIZE', 'Insecure\x20origin', 'INVALID_DATA', '_initializeBackground', 'FAIL_LOAD_WASM', 'INVALID_DEVICE_KEY_IDENTIFIER', 'raw', 'INCORRECT_CAMERA_ID', 'FEEDBACK_LICENSE_INVALID', 'DEVICE_IN_LANDSCAPE_MODE', 'IDENTIFICATIONS_REQUIRED', 'DIFFERENT_ZONE', 'next', 'DEVICE_BROWSER_ERROR', 'VIDEO_PLAYING_ERROR', 'INCORRECT_FILE', 'INITIALIZATION_NOT_COMPLETED', 'WASM_LICENSE', 'NO_CAPTURE_TYPE', '6lAKBlPagKFclCK3', 'fad-iframe-signature', 'FAILED_SEND_VALIDATION', '0.0.1', 'sandbox', 'VIDEO_CREATION_FAIL', '114443GGLIZE', 'ENROLLMENT', 'CAMERA_PERMISSION_DENIED', 'iframeId', 'VERSION_DEPRECATED', 'fad-iframe-regula-id', 'allow-scripts', 'FAST', 'FAILED_GET_VALIDATION', 'border', 'STILL_LOADING_RESOURCES', 'FACETEC_MIDDLEWARE_REQUEST_FAILED', 'startVideotaping', 'UNKNOWN_ERROR', 'SESSION_IN_PROGRESS', 'NO_MODEL_URL', 'startValidationId', 'IN_PROCESS', 'ID_PASSPORT', 'CAMERA_UNKNOWN_ERROR', 'then', 'VIDEOAGREEMENT', 'INVALID_SIGNATURE', 'CAMERA_NOT_ENABLED', 'RESOURCES_COULD_NOT_BE_LOADED_ON_LAST_INIT', 'NOT_INITIALIZED', 'ALLOW_SAME_ORIGIN', 'REQUIRED_CREDENTIALS', 'log', 'ID_PHOTO_NOT_FOUND', 'FAIL_UPLOAD_IMAGE', 'UNSUPPORTED_CAMERA', 'ERROR_LICENSE', 'postMessage', 'IMAGE_BLURRY', 'TIME_OUT', 'CONTEXT_SWITCH', 'TIMEOUT_EXCEEDED', 'tv5lzF1ZGLD0dsA2E6j5VxwmBiMXgdKhcbAh3QpRUkXBBA==', '1951615KEXwwg', 'Regula\x20starts', 'CAMERA', 'connectedCallback', 'Process\x20error', 'EQUAL_SIDE', 'USER_CANCELLED_WHEN_ATTEMPTING_TO_GET_CAMERA_PERMISSIONS', 'geolocation;\x20camera;\x20microphone', 'TIMEOUT', 'FEEDBACK_RETRY', 'data', 'NEVER_INITIALIZED', 'subtle', 'charCodeAt', 'allowFullscreen', 'BAD_CREDENTIALS', 'INITIALIZED', 'OTHER', 'UAT', 'SIGNATURE', 'PROD', 'camera', 'origin', 'GEOLOCATION_CAMERA_MICROPHONE', 'FAIL_CREATION_INSTANCE_DOCUMENT', 'JIxcqVf2MMP5dDS5PlcZdWRE00J9F8IGS/FyFPo0AEs=', 'fad-sdk-iframe', 'INIT_MODULE', 'FACE_IMAGE_URL_NOT_FOUND', 'TEACHABLE_MACHINE_LOAD_FAIL', 'PROGRAMMATICALLY_CANCELLED', 'ENTRY_PATH', 'FACETEC_SESSION_STATUS', 'CAMERA_SNAPSHOT', 'createElement', 'tkn', 'FACE_IMAGE_NOT_FOUND', 'version', 'startFadWeb4', 'NO_CARD_TYPE', 'CAMERA_ACCEPTED', 'backgroundColor', 'uONj0U8CQuv/dMQ2BaCxRhImH+A5OSiunldOn9NESHEoUaS8TeRJDAsScfQULGYiPrCMEgqEAw==', 'removeFadSdkElement', '24577542wUFNyO', 'FILE_FORMAT', 'Constants', 'VALIDATION_ID', '_fadBackground', 'MEDIA_RECORDER_ERROR', 'width', 'left', 'security', 'fad-sdk', 'USER_NOT_EXIST', 'addEventListener', '9362101luDuFU', 'DPI_NOT_ENOUGH', 'Starts\x20FAD\x20SDK\x20Process', 'NON_PRODUCTION_MODE_DEVICE_KEY_IDENTIFIER_INVALID', 'NO_CITIZEN_IDENTIFIER', 'FAIL_GET_OCR', 'fadSdkElement', 'FACETEC_SDK_STATUS', 'ORIENTATION', 'NETWORK_ISSUES', 'FacetecMiddlewareError', 'SERVICES_URL_NOT_CONFIGURED', 'TIMEOUT_CAPTURE', 'top', 'NO_FINGERS', 'NOT_ALLOWED_USE_NON_IFRAME_CONSTRUCTOR', 'toString', 'SLOW', 'DOCUMENT_NOT_READY', 'encrypt', 'FAIL_GET_FACE_IMAGE', 'src', 'buffer', 'value', 'USER_CANCELLED', 'done', 'ERROR_REQUEST_EXPIRED', 'height', 'MODULE_LOAD_FAILED', 'Process\x20completed', 'FAIL_INITIALIZATION', 'NO_INTERNET', 'DIFFERENT_CARD_TYPE', 'FACETEC_MIDDLEWARE_CREDENTIALS', 'NOT_PREPARED', 'MEDIUM', 'REQUIRED_SIGNATURE', 'body', 'position', 'FAD_TIMEOUT', 'FACETEC', 'Process\x20Completed', 'FACETEC_MIDDLEWARE_ERROR', '9cylsAG', 'contentWindow', 'NEVERIN_ITIALIZED', '399066zlYKKH', 'fad-iframe-acuant-beta', 'fixed', 'NO_CAMERA', 'WASM_ERROR', 'ERROR_WEBRTC_NOT_SUPPORTED', 'define', 'domain', 'USER_CANCELLED_FROM_RETRY_GUIDANCE', 'ALLOW_SCRIPTS', 'IDENTY_GENERIC', 'apply', 'URL:', 'importKey', 'fad-iframe-validation-id', 'MODULE_CLOSED', 'event', 'ALLOW_MODALS', 'RESOURCES_COULD_NOT_BE_LOADED', 'VIDEOTAPING', 'crypto', 'FACE_UNDETECTED', 'style', 'IMAGE_GLARED', 'FEEDBACK_CAMERA_ACQUIRING_FAILED', 'ID_NOT_FOUND', 'DOCUMENT_READER', 'uONj0U8CQuvucMYgEKuxVRd/VKg2IjeinkNPhNtRW3YvHumwT6YLMrrhRSU+9tUiIR8w90l6GoYN3hQEgIAnjb4N', 'Acuant\x20starts', 'startFacetec', 'fad-iframe-videoagreement', 'NO_CREDENTIALS', 'allow-modals', '9483752MtMjeJ', 'startIdenty', 'message', 'DEVICE_NOT_SUPPORTED', 'USER_NOT_CONFIGURED', 'NO_SERVICE', '#F2F2F2', 'ID_MEX_BACK', 'DEVICE_LOCKED_OUT', 'NO_AUDIO', 'FAIL_INITIALIZATION_CAMERA_UI', 'includes', 'fad-iframe-identy', 'REGULA_ERROR', 'options', 'iframe', 'startVideoagreement', 'NOT_ALLOWED_USE_IFRAME_CONSTRUCTOR', 'NOT_SUPPORTED', 'MISSING_GUIDANCE_IMAGES', 'KEY_EXPIRED_OR_INVALID', 'removeChild', 'USER_CANCELLED_VIA_CLICKABLE_READY_SCREEN_SUBTEXT', 'DIV', 'ACUANT_10', 'appendChild', 'ORIENTATION_CHANGE_DURING_SESSION', 'PROCESS_ERROR', 'CAMERA_MICROPHONE', 'VALIDATION', 'removeEventListener', 'REQUIRED_LEGEND', 'startAcuant', 'USER_CANCELLED_FROM_NEW_USER_GUIDANCE', '28kwNWHv', 'UNKNOWN_INTERNAL_ERROR', 'ALLOW_FORMS', 'FaceTecSessionStatus', 'LOCKED_OUT'];
  _0x3abf = function _0x3abf() {
    return _0x3c6610;
  };
  return _0x3abf();
}
function addElementToFadTag(_0x5330af) {
  var _0xa549ed = _0x7f9bb9;
  var _0x1e6968;
  var _0x49db74 = getFadTag();
  (_0x1e6968 = _0x49db74 === null || _0x49db74 === void 0x0 ? void 0x0 : _0x49db74['shadowRoot']) === null || _0x1e6968 === void 0x0 ? void 0x0 : _0x1e6968[_0xa549ed(0x17e)](_0x5330af);
}
function addFadTag(_0x5ad4d9) {
  var _0x542591 = _0x7f9bb9;
  var _0x190034;
  var _0x3982ba = _0x542591(0x113),
    _0x611306 = document[_0x542591(0x100)](_0x542591(0x113));
  _0x611306['id'] = _0x3982ba;
  var _0x4569d1 = (_0x190034 = _0x5ad4d9 === null || _0x5ad4d9 === void 0x0 ? void 0x0 : _0x5ad4d9['zIndex']) === null || _0x190034 === void 0x0 ? void 0x0 : _0x190034[_0x542591(0x126)]();
  return _0x611306[_0x542591(0x15a)]['zIndex'] = _0x4569d1 || '88888', _0x611306;
}
function createIframe(_0x4c1857, _0x1ea28b, _0x486db4, _0x369fab, _0x1631e5) {
  var _0x290468 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !![];
  var _0x275640 = _0x7f9bb9,
    _0x3bdd0a = document[_0x275640(0x100)](_0x275640(0x174));
  return _0x369fab[_0x275640(0x19c)](function (_0x5e8bba) {
    var _0x41bcbc = _0x275640;
    _0x3bdd0a[_0x41bcbc(0x1cd)]['add'](_0x5e8bba);
  }), _0x3bdd0a[_0x275640(0x1a4)] = _0x1631e5, _0x3bdd0a[_0x275640(0x204)] = _0x290468, _0x3bdd0a[_0x275640(0x15a)][_0x275640(0x1d8)] = '0', _0x3bdd0a['style'][_0x275640(0x13c)] = 'fixed', _0x3bdd0a[_0x275640(0x15a)][_0x275640(0x110)] = _0x275640(0x196), _0x3bdd0a[_0x275640(0x15a)][_0x275640(0x131)] = _0x275640(0x196), _0x3bdd0a[_0x275640(0x15a)][_0x275640(0x111)] = '0', _0x3bdd0a[_0x275640(0x15a)]['top'] = '0', _0x3bdd0a['style']['zIndex'] = '888888', _0x3bdd0a[_0x275640(0x12b)] = _0x1ea28b + '?tkn=' + _0x486db4, _0x3bdd0a;
}
function decipher(_0x4039fc, _0x2f069c, _0x1bdad2) {
  return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var _0x44cb44, _0x4ce9d7, _0x5c58d2;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _0x44cb44 = _0x53be;
          _context4.t0 = window['crypto'][_0x44cb44(0x202)];
          _context4.t1 = {
            'name': _0x44cb44(0x1b0),
            'iv': base64ToBytes(_0x1bdad2)
          };
          _context4.next = 5;
          return parseKey(_0x2f069c);
        case 5:
          _context4.t2 = _context4.sent;
          _context4.t3 = base64ToBytes(_0x4039fc);
          _context4.next = 9;
          return _context4.t0['decrypt'].call(_context4.t0, _context4.t1, _context4.t2, _context4.t3);
        case 9:
          _0x4ce9d7 = _context4.sent;
          _0x5c58d2 = new TextDecoder();
          return _context4.abrupt("return", _0x5c58d2[_0x44cb44(0x19a)](_0x4ce9d7));
        case 12:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
}
function base64ToBytes(_0x1badc4) {
  var _0xfd2db2 = _0x7f9bb9,
    _0x1efcdf = atob(_0x1badc4),
    _0x45e877 = new Uint8Array(_toConsumableArray(_0x1efcdf)['map'](function (_0x53654c) {
      return _0x53654c[_0xfd2db2(0x203)](0x0);
    }));
  return _0x45e877[_0xfd2db2(0x12c)];
}
function parseKey(_0x26a272) {
  return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var _0x7f6ab, _0x22b8ed, _0x267b8d;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _0x7f6ab = _0x53be;
          _0x22b8ed = base64ToBytes(_0x26a272);
          _context5.next = 4;
          return window[_0x7f6ab(0x158)][_0x7f6ab(0x202)][_0x7f6ab(0x151)](_0x7f6ab(0x1bc), _0x22b8ed, _0x7f6ab(0x1b0), ![], [_0x7f6ab(0x129), 'decrypt']);
        case 4:
          _0x267b8d = _context5.sent;
          return _context5.abrupt("return", _0x267b8d);
        case 6:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
}
var FadSDK = /*#__PURE__*/function (_x7f9bb, _x7f9bb2, _x7f9bb3, _x7f9bb4, _x7f9bb5, _x7f9bb6, _x7f9bb7, _x7f9bb8, _x7f9bb9, _x7f9bb10) {
  function FadSDK(_0x334fb2, _0x24d2fa) {
    _classCallCheck(this, FadSDK);
    var _0x1b3d42 = _0x7f9bb9;
    this[_0x1b3d42(0x101)] = '', this[_0x1b3d42(0x1d2)] = _0x1b3d42(0x210), this['tkn'] = _0x334fb2, this['options'] = _0x24d2fa || SDK_OPTIONS, this[_0x1b3d42(0x11c)] = addFadTag(_0x24d2fa === null || _0x24d2fa === void 0x0 ? void 0x0 : _0x24d2fa[_0x1b3d42(0x15a)]), document[_0x1b3d42(0x13b)][_0x1b3d42(0x17e)](this[_0x1b3d42(0x11c)]);
  }
  return _createClass(FadSDK, [{
    key: _x7f9bb,
    value: function value(_0x52ce16, _0xa92198, _0x53a66a) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _0x167baf, _0x1fa7bb;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _0x167baf = _0x53be;
              _context6.t0 = createIframe;
              _context6.t1 = this[_0x167baf(0x1d2)];
              _context6.next = 5;
              return this[_0x167baf(0x18e)]();
            case 5:
              _context6.t2 = _context6.sent;
              _context6.t3 = '' + _context6.t2;
              _context6.t4 = MODULES_URL[_0x167baf(0x13e)];
              _context6.t5 = _context6.t3 + _context6.t4;
              _context6.t6 = this['tkn'];
              _context6.t7 = [SandBoxPermissions[_0x167baf(0x14d)], SandBoxPermissions['ALLOW_SAME_ORIGIN']];
              _context6.t8 = IframePermissions[_0x167baf(0x1f8)];
              _0x1fa7bb = (0, _context6.t0)(_context6.t1, _context6.t5, _context6.t6, _context6.t7, _context6.t8);
              return _context6.abrupt("return", startFadSDKProcess(_0x1fa7bb, {
                'credentials': _0x52ce16,
                'configuration': _0xa92198,
                'middleware': _0x53a66a
              }, this[_0x167baf(0x173)]));
            case 14:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: _x7f9bb2,
    value: function value(_0x205d14, _0x268ce8, _0x274d54, _0x5600c1) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _0x2d23b1, _0x2f6254;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _0x2d23b1 = _0x53be;
              console[_0x2d23b1(0x1eb)](_0x2d23b1(0x160));
              _context7.t0 = console;
              _context7.t1 = _0x2d23b1(0x1eb);
              _context7.next = 6;
              return this[_0x2d23b1(0x18e)]();
            case 6:
              _context7.t2 = _context7.sent;
              _context7.t0[_context7.t1].call(_context7.t0, _context7.t2);
              _context7.t3 = createIframe;
              _context7.t4 = this[_0x2d23b1(0x1d2)];
              _context7.next = 12;
              return this[_0x2d23b1(0x18e)]();
            case 12:
              _context7.t5 = _context7.sent;
              _context7.t6 = '' + _context7.t5;
              _context7.t7 = MODULES_URL[_0x2d23b1(0x17d)];
              _context7.t8 = _context7.t6 + _context7.t7;
              _context7.t9 = this['tkn'];
              _context7.t10 = [SandBoxPermissions[_0x2d23b1(0x14d)], SandBoxPermissions[_0x2d23b1(0x1e9)]];
              _context7.t11 = _0x2d23b1(0x20b);
              _0x2f6254 = (0, _context7.t3)(_context7.t4, _context7.t8, _context7.t9, _context7.t10, _context7.t11);
              return _context7.abrupt("return", startFadSDKProcess(_0x2f6254, {
                'credentials': _0x205d14,
                'idData': _0x268ce8,
                'idPhoto': _0x274d54,
                'configuration': _0x5600c1
              }, this['options']));
            case 21:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: 'startRegula',
    value: function startRegula(_0x4e3d71, _0x382508, _0x560e27, _0x53a0d8, _0x2a5283) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _0x596bae, _0x293414;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _0x596bae = _0x53be;
              console['log'](_0x596bae(0x1f7));
              _context8.t0 = createIframe;
              _context8.t1 = this[_0x596bae(0x1d2)];
              _context8.next = 6;
              return this[_0x596bae(0x18e)]();
            case 6:
              _context8.t2 = _context8.sent;
              _context8.t3 = '' + _context8.t2;
              _context8.t4 = MODULES_URL['REGULA'];
              _context8.t5 = _context8.t3 + _context8.t4;
              _context8.t6 = this['tkn'];
              _context8.t7 = [SandBoxPermissions[_0x596bae(0x14d)], SandBoxPermissions[_0x596bae(0x1e9)]];
              _context8.t8 = IframePermissions[_0x596bae(0x1f8)];
              _0x293414 = (0, _context8.t0)(_context8.t1, _context8.t5, _context8.t6, _context8.t7, _context8.t8);
              return _context8.abrupt("return", startFadSDKProcess(_0x293414, {
                'credentials': _0x4e3d71,
                'idData': _0x382508,
                'idPhoto': _0x560e27,
                'configuration': _0x2a5283,
                'captureType': _0x53a0d8
              }, this[_0x596bae(0x173)]));
            case 15:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: _x7f9bb3,
    value: function value(_0x47a0ff, _0x101bb3) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _0x2ec3d8, _0x25d189;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _0x2ec3d8 = _0x53be;
              _context9.t0 = createIframe;
              _context9.t1 = this[_0x2ec3d8(0x1d2)];
              _context9.next = 5;
              return this['getBaseUrl']();
            case 5:
              _context9.t2 = _context9.sent;
              _context9.t3 = '' + _context9.t2;
              _context9.t4 = MODULES_URL[_0x2ec3d8(0x1e4)];
              _context9.t5 = _context9.t3 + _context9.t4;
              _context9.t6 = this[_0x2ec3d8(0x101)];
              _context9.t7 = [SandBoxPermissions[_0x2ec3d8(0x14d)], SandBoxPermissions[_0x2ec3d8(0x1e9)]];
              _context9.t8 = IframePermissions[_0x2ec3d8(0x181)];
              _0x25d189 = (0, _context9.t0)(_context9.t1, _context9.t5, _context9.t6, _context9.t7, _context9.t8);
              return _context9.abrupt("return", startFadSDKProcess(_0x25d189, {
                'legend': _0x47a0ff,
                'configuration': _0x101bb3
              }, this[_0x2ec3d8(0x173)]));
            case 14:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: _x7f9bb4,
    value: function value(_0x37810c, _0x365767, _0x498543) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _0x1a8ad, _0x38a69c;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _0x1a8ad = _0x53be;
              _context10.t0 = createIframe;
              _context10.t1 = this['iframeId'];
              _context10.next = 5;
              return this[_0x1a8ad(0x18e)]();
            case 5:
              _context10.t2 = _context10.sent;
              _context10.t3 = '' + _context10.t2;
              _context10.t4 = MODULES_URL[_0x1a8ad(0x157)];
              _context10.t5 = _context10.t3 + _context10.t4;
              _context10.t6 = this[_0x1a8ad(0x101)];
              _context10.t7 = [SandBoxPermissions[_0x1a8ad(0x14d)], SandBoxPermissions[_0x1a8ad(0x1e9)]];
              _context10.t8 = IframePermissions[_0x1a8ad(0x181)];
              _0x38a69c = (0, _context10.t0)(_context10.t1, _context10.t5, _context10.t6, _context10.t7, _context10.t8);
              return _context10.abrupt("return", startFadSDKProcess(_0x38a69c, {
                'legend': _0x37810c,
                'identifications': _0x365767,
                'configuration': _0x498543
              }, this[_0x1a8ad(0x173)]));
            case 14:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: _x7f9bb5,
    value: function value(_0x51a725) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _0x3fb068, _0x1ab739;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _0x3fb068 = _0x53be;
              _context11.t0 = createIframe;
              _context11.t1 = this[_0x3fb068(0x1d2)];
              _context11.next = 5;
              return this['getBaseUrl']();
            case 5:
              _context11.t2 = _context11.sent;
              _context11.t3 = '' + _context11.t2;
              _context11.t4 = MODULES_URL['SIGNATURE'];
              _context11.t5 = _context11.t3 + _context11.t4;
              _context11.t6 = this[_0x3fb068(0x101)];
              _context11.t7 = [SandBoxPermissions[_0x3fb068(0x14d)], SandBoxPermissions[_0x3fb068(0x1e9)]];
              _context11.t8 = IframePermissions[_0x3fb068(0x181)];
              _0x1ab739 = (0, _context11.t0)(_context11.t1, _context11.t5, _context11.t6, _context11.t7, _context11.t8);
              return _context11.abrupt("return", startFadSDKProcess(_0x1ab739, {
                'configuration': _0x51a725
              }, this[_0x3fb068(0x173)]));
            case 14:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: _x7f9bb6,
    value: function value(_0x31162d, _0x3c4901) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _0x2560e7, _0x53e3db;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _0x2560e7 = _0x53be;
              _context12.t0 = createIframe;
              _context12.t1 = this[_0x2560e7(0x1d2)];
              _context12.next = 5;
              return this['getBaseUrl']();
            case 5:
              _context12.t2 = _context12.sent;
              _context12.t3 = '' + _context12.t2;
              _context12.t4 = MODULES_URL[_0x2560e7(0x10d)];
              _context12.t5 = _context12.t3 + _context12.t4;
              _context12.t6 = this[_0x2560e7(0x101)];
              _context12.t7 = [SandBoxPermissions[_0x2560e7(0x14d)], SandBoxPermissions[_0x2560e7(0x1e9)], SandBoxPermissions['ALLOW_MODALS']];
              _0x53e3db = (0, _context12.t0)(_context12.t1, _context12.t5, _context12.t6, _context12.t7, '');
              return _context12.abrupt("return", startFadSDKProcess(_0x53e3db, {
                'identificationData': _0x31162d,
                'configuration': _0x3c4901
              }, this['options']));
            case 13:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: _x7f9bb7,
    value: function value(_0x4db75b, _0x5813c0, _0x53d47c) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _0x558d1e, _0x4441f1;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _0x558d1e = _0x53be;
              _context13.t0 = createIframe;
              _context13.t1 = this[_0x558d1e(0x1d2)];
              _context13.next = 5;
              return this['getBaseUrl']();
            case 5:
              _context13.t2 = _context13.sent;
              _context13.t3 = '' + _context13.t2;
              _context13.t4 = MODULES_URL['IDENTY'];
              _context13.t5 = _context13.t3 + _context13.t4;
              _context13.t6 = this[_0x558d1e(0x101)];
              _context13.t7 = [SandBoxPermissions[_0x558d1e(0x14d)], SandBoxPermissions[_0x558d1e(0x1e9)], SandBoxPermissions[_0x558d1e(0x155)]];
              _context13.t8 = IframePermissions['CAMERA'];
              _0x4441f1 = (0, _context13.t0)(_context13.t1, _context13.t5, _context13.t6, _context13.t7, _context13.t8);
              return _context13.abrupt("return", startFadSDKProcess(_0x4441f1, {
                'detectionModes': _0x4db75b,
                'captureTimeout': _0x5813c0,
                'configuration': _0x53d47c
              }, this[_0x558d1e(0x173)]));
            case 14:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: _x7f9bb8,
    value: function value(_0x146eac) {
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _0x42729a, _0x1a3a22, _0x831c4c;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _0x42729a = _0x53be;
              _context14.next = 3;
              return this[_0x42729a(0x18e)](!![]);
            case 3:
              _0x1a3a22 = _context14.sent;
              console['log'](_0x42729a(0x150), '' + _0x1a3a22 + _0x146eac);
              _0x831c4c = createIframe(this[_0x42729a(0x1d2)], '' + _0x1a3a22 + _0x146eac, this[_0x42729a(0x101)], [SandBoxPermissions['ALLOW_SCRIPTS'], SandBoxPermissions[_0x42729a(0x1e9)], SandBoxPermissions[_0x42729a(0x155)], SandBoxPermissions[_0x42729a(0x189)]], IframePermissions[_0x42729a(0x20d)]);
              return _context14.abrupt("return", startFadWebProcess(_0x831c4c, this['options']));
            case 7:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: _x7f9bb9,
    value: function value() {
      var _0xec4d68 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ![];
      var _0x378b41, _0x318b2d;
      return __awaiter(this, void 0x0, void 0x0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var _0x4f1d7d, _0x23b241;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _0x4f1d7d = _0x53be;
              if (!((_0x378b41 = this[_0x4f1d7d(0x173)]) === null || _0x378b41 === void 0x0 ? void 0x0 : _0x378b41[_0x4f1d7d(0x1ac)])) {
                _context15.next = 14;
                break;
              }
              _context15.t0 = this[_0x4f1d7d(0x173)][_0x4f1d7d(0x1ac)];
              _context15.next = _context15.t0 === FadEnvironment[_0x4f1d7d(0x208)] ? 5 : _context15.t0 === FadEnvironment[_0x4f1d7d(0x20a)] ? 7 : 9;
              break;
            case 5:
              _0x23b241 = _0xec4d68 ? FAD_WEB_UAT : FAD_IFRAME_UAT;
              return _context15.abrupt("break", 9);
            case 7:
              _0x23b241 = _0xec4d68 ? FAD_WEB_PROD : FAD_IFRAME_PROD;
              return _context15.abrupt("break", 9);
            case 9:
              _context15.next = 11;
              return decipher(_0x23b241, YEK, VI);
            case 11:
              return _context15.abrupt("return", _context15.sent);
            case 14:
              return _context15.abrupt("return", ((_0x318b2d = this[_0x4f1d7d(0x173)]) === null || _0x318b2d === void 0x0 ? void 0x0 : _0x318b2d['baseUrl']) ? this[_0x4f1d7d(0x173)]['baseUrl'] : FAD_IFRAME_UAT);
            case 15:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: 'end',
    value: function end() {
      this['removeFadSdkElement']();
    }
  }, {
    key: _x7f9bb10,
    value: function value() {
      var _0x5aee03 = _0x7f9bb9;
      document[_0x5aee03(0x13b)][_0x5aee03(0x17a)](this[_0x5aee03(0x11c)]);
    }
  }], [{
    key: 'getFadEnvironments',
    value: function getFadEnvironments() {
      return FadEnvironment;
    }
  }]);
}(_0x7f9bb9(0x161), _0x7f9bb9(0x185), _0x7f9bb9(0x175), _0x7f9bb9(0x1db), _0x7f9bb9(0x1b3), _0x7f9bb9(0x1df), _0x7f9bb9(0x166), _0x7f9bb9(0x104), _0x7f9bb9(0x18e), _0x7f9bb9(0x109));
FadSDK['Errors'] = {
  'Acuant': AcuantErrorCode,
  'Identy': IdentyErrorCode,
  'Signature': SignatureErrorCode,
  'ValidationId': ValidationIdErrorCode,
  'Videotaping': VideotapingErrorCode,
  'Videoagreement': VideoagreementErrorCode,
  'Facetec': {
    'Session': FacetecErrorCodeSession,
    'Status': FacetecErrorCodeStatus,
    'Middleware': IframeFacetecErrorCode,
    'Type': FacetecErrorType
  },
  'Regula': RegulaErrorCode
}, FadSDK[_0x7f9bb9(0x10c)] = {
  'EventModule': EventModule,
  'Regula': {
    'CaptureType': RegulaCaptureType
  },
  'Facetec': {
    'ProcessType': AdditionaInfoProcessType
  },
  'Videotaping': {
    'IdsAllowed': IDS_ALLOWED
  },
  'Videoagreement': {
    'LegendSpeedMode': LegendSpeedMode
  }
}, FadSDK[_0x7f9bb9(0x103)] = _0x7f9bb9(0x1cc);
var FadSdkElement = /*#__PURE__*/function (_HTMLElement, _x7f9bb11, _x7f9bb12) {
  function FadSdkElement() {
    var _this;
    _classCallCheck(this, FadSdkElement);
    var _0x57a751 = _0x7f9bb9;
    _this = _callSuper(this, FadSdkElement), _this[_0x57a751(0x10e)], _this[_0x57a751(0x18c)]({
      'mode': 'open'
    });
    return _this;
  }
  _inherits(FadSdkElement, _HTMLElement);
  return _createClass(FadSdkElement, [{
    key: _x7f9bb11,
    value: function value() {
      var _0x4c388c = _0x7f9bb9;
      var _0x1ece02;
      this['_initializeBackground'](), (_0x1ece02 = this[_0x4c388c(0x1a1)]) === null || _0x1ece02 === void 0x0 ? void 0x0 : _0x1ece02[_0x4c388c(0x17e)](this[_0x4c388c(0x10e)]), console[_0x4c388c(0x1eb)]('Fad\x20Sdk\x20Element\x20initialized');
    }
  }, {
    key: _x7f9bb12,
    value: function value() {
      var _0x359b6f = _0x7f9bb9;
      this[_0x359b6f(0x10e)] = document['createElement'](_0x359b6f(0x17c)), this[_0x359b6f(0x10e)][_0x359b6f(0x15a)][_0x359b6f(0x107)] = _0x359b6f(0x16b), this[_0x359b6f(0x10e)][_0x359b6f(0x15a)][_0x359b6f(0x110)] = _0x359b6f(0x196), this[_0x359b6f(0x10e)][_0x359b6f(0x15a)]['height'] = _0x359b6f(0x196), this[_0x359b6f(0x10e)]['style'][_0x359b6f(0x13c)] = _0x359b6f(0x146), this[_0x359b6f(0x10e)]['style'][_0x359b6f(0x123)] = '0', this[_0x359b6f(0x10e)][_0x359b6f(0x15a)]['left'] = '0';
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement), _0x7f9bb9(0x1f9), _0x7f9bb9(0x1b9));
customElements['get']('fad-sdk') || customElements[_0x7f9bb9(0x14a)]('fad-sdk', FadSdkElement);
export { FadSDK as default };